import { defineEnv } from "envin";

import { envConfig } from "@workspace/shared/constants";

import { preset as paypalPreset } from "./paypal/env";
import { preset as stripePreset } from "./stripe/env";

import type { Preset } from "envin/types";

export const preset = {
  id: "billing-web-providers",
  extends: [stripePreset, paypalPreset],
} as const satisfies Preset;

export const env = defineEnv({
  ...envConfig,
  ...preset,
});

export { paypalPreset, stripePreset };
